import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class InstructivoEmbarqueNavigationService {
  constructor(private router: Router) {}

  openWizardFromItinerary(
    voyageId: number,
    portOfLoadingId: number,
    portOfDischargeId: number,
  ): void {
    const urlTree = this.router.createUrlTree(['/instructivo-embarque/wizard'], {
      queryParams: { voyageId, portOfLoadingId, portOfDischargeId },
    });
    const url = this.router.serializeUrl(urlTree);
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  openListFromItinerary(voyageId: number): void {
    const urlTree = this.router.createUrlTree(['/instructivo-embarque/list'], {
      queryParams: { voyageId },
    });
    const url = this.router.serializeUrl(urlTree);
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  goBack(): void {
    this.router.navigate(['/itinerarios']);
  }
}
